import { render } from "./TableScrollbar.vue?vue&type=template&id=51020a68&scoped=true"
import script from "./TableScrollbar.vue?vue&type=script&lang=js"
export * from "./TableScrollbar.vue?vue&type=script&lang=js"

import "./TableScrollbar.vue?vue&type=style&index=0&id=51020a68&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51020a68"]])

export default __exports__